const titles = document.querySelectorAll(".featured-collection__switcher-title");
const collections = document.querySelectorAll(".featured-collection__collection");
const swiper = document.querySelectorAll(".featured-collection__collection-swiper .swipper-wrapper");

// Handle collection change on tab click
titles.forEach(title => {
  title.addEventListener('click', () => {
    let titleActive = document.querySelector('.featured-collection__switcher-title--is-active');
    titleActive?.classList.remove('featured-collection__switcher-title--is-active');
    title.classList.add('featured-collection__switcher-title--is-active');
    swiper.forEach(swipe => {
      swipe.style.transform = 'translate3d(0px, 0, 0)';
    });
    collections.forEach(collection => {
      collection.classList.remove('featured-collection__collection--is-visible');
    });
    let target = title.getAttribute('data-target');
    document.querySelector(`#${target}`).classList.add('featured-collection__collection--is-visible');
  });
});